import * as React from "react";
import AriaTooltip from "../Tooltip/AriaTooltip";

export interface ITypographySectionProps {
    title: string | JSX.Element;
    data: any;
    tooltip?: any;
}

export interface ITypographyProps {
    type: "vertical" | "narrow" | "common" | "auto-width" | "wider" | "narrow-dt-width";
    config: ITypographySectionProps[];
    wrapCss?: string;
    colNum?: number; // default 1
}

export const Typography = (props: ITypographyProps) => {
    if (props.colNum < 0 || props.colNum > 12) {
        console.error("invalid colNum! must less than 12 and more than 0!");
        return;
    }

    const { type, config, wrapCss, colNum } = props;
    let wrapperCssNew = wrapCss + " def-list ";
    switch (type) {
        case "vertical":
            wrapperCssNew += "vertical";
            break;
        case "narrow":
            wrapperCssNew += "narrow";
            break;
        case "auto-width":
            wrapperCssNew += "auto-width";
            break;
        case "wider":
            wrapperCssNew += "wider";
            break;
        case "narrow-dt-width":
            wrapperCssNew += "narrow-dt-width";
            break;
        default:
            break;
    }

    const _colNum = colNum || 1;

    const renderSet = (ele: ITypographySectionProps, index: number) => {
        return ele.data ? (
            <div key={`list-${index}`}>
                <dt>
                    <div className="row-auto">
                        {ele.title}
                        {ele.tooltip != null && (
                            <AriaTooltip cssWrapper="is-info-icon ml-5" showCloseButton={true}>
                                {ele.tooltip}
                            </AriaTooltip>
                        )}
                    </div>
                </dt>
                <dd>{ele.data}</dd>
            </div>
        ) : null;
    };

    const renderColSection = (colConfig: ITypographySectionProps[]) => {
        let index = 0;
        const viewItems = [];
        while (index < colConfig.length) {
            if (_colNum === 1) {
                const view = renderSet(colConfig[index], index);
                viewItems.push(view);
            } else {
                const _data = colConfig.slice(index, index + _colNum);
                const view = _data.map((item, i) => {
                    return (
                        <div className={`col-${parseInt((12 / _colNum).toString())}`}>{renderSet(item, index + i)}</div>
                    );
                });
                viewItems.push(<div className="row">{view}</div>);
            }
            index = index + _colNum;
        }
        return viewItems;
    };

    return <dl className={wrapperCssNew}>{renderColSection(config)}</dl>;
};
